import { fromEventPattern, fromEvent } from "rxjs";


const DEFAULT_CURSOR = "default";

const _sideClickPrecision = 4;
const _debug = false;
    
export default class DataPointTransform {

    constructor(viewer, startCondition) {
        this.viewer = viewer;
        this.startCondition = startCondition;
        this.active = true;
        this.transforming = false;
        this.currentDataPoint = null;
        this.drawArea = null;
        this.dataPoints = [];
        this.finishedObservable = new Rx.Subject();
        this.cursor = undefined;
        this.subscriptions = _addInputHook(this);
    }

    addDataPoint(dataPoint) {
        if(!this.dataPoints.includes(dataPoint)) {
            this.dataPoints.push(dataPoint);
            return true;
        }
        return false;
    }

    removeDataPoint(dataPoint) {
        if(this.dataPoints.includes(dataPoint)) {
            var index = this.dataPoints.indexOf(dataPoint);
            this.dataPoints.splice(index, 1);
            return true;
        }
        return false;
    }

    finishedTransforming() {
        return this.finishedObservable;
    }

    close() {
        this.active = false;
        this.finishedObservable.onCompleted();
        this.subscriptions.forEach(subscr => subscr.unsubscribe());
        this.subscriptions = [];
    }

    isActive() {
        return this.active;
    }

    isTransforming () {
        return this.transforming;
    }

    getContainingDataPoint(point) {
        for(var index in this.dataPoints) {
            var dataPoint = this.dataPoints[index];
            if(dataPoint.contains(point, _sideClickPrecision, true)) {
                return dataPoint;
            } 
        }
        return null;
    }
}

    
    function _addInputHook(transform) {
        const subscriptions = [
            fromEventPattern( handler => this.viewer.addHandler("canvas-click", handler), handler => this.viewer.removeHandler("canvas-click", handler))
                .subscribe(e =>  _disableViewerEvent(e, transform)),

            fromEventPattern( handler => this.viewer.addHandler("canvas-drag", handler), handler => this.viewer.removeHandler("canvas-drag", handler))
                .subscribe(e =>  _onViewerDrag(e, transform)),

            fromEventPattern( handler => this.viewer.addHandler("canvas-press", handler), handler => this.viewer.removeHandler("canvas-press", handler))
                .subscribe(e =>  _onViewerPress(e, transform)),

            fromEventPattern( handler => this.viewer.addHandler("canvas-drag-end", handler), handler => this.viewer.removeHandler("canvas-drag-end", handler))
                .subscribe(e =>  _onViewerDragEnd(e, transform)),

            fromEventPattern( handler => this.viewer.addHandler("canvas-release", handler), handler => this.viewer.removeHandler("canvas-release", handler))
                .subscribe(e =>  _onViewerRelease(e, transform)),

            fromEvent(this.viewer.element, "mousemove")
                .subscribe(e => _onViewerMove(e, transform)),
        ]

        return subscriptions;
    }


    function _onViewerMove( event, transform ) {
        if ( !transform.isTransforming() && transform.isActive() && transform.startCondition(event.originalEvent) ) {
            var coords = new OpenSeadragon.Point(event.position.x, event.position.y);
            var dataPoint = transform.getContainingDataPoint(coords);
            var viewerElement = transform.viewer.element;
            if(dataPoint) {
                transform.currentDataPoint = dataPoint;
                transform.drawArea = dataPoint.getHitArea(coords, _sideClickPrecision, true);
            } else {
                transform.currentDataPoint = null;
                transform.drawArea = null;
            }
            if ( transform.drawArea ) {
            	var cursor = imageView.DataPoint.HitAreas.getCursor( transform.drawArea, dataPoint.style );
            	if(transform.cursor != cursor) {
            		transform.cursor = cursor;
            		$( viewerElement ).css( {cursor: cursor} );
            	}
            } else if(transform.cursor) {
            	transform.cursor = undefined;
            	$( viewerElement ).css( {cursor: DEFAULT_CURSOR} );
            }
            event.preventDefaultAction = true;
            return true;
        }
    }
    
    function _onViewerPress( event, transform ) {
        if ( transform.isActive()  && transform.startCondition(event.originalEvent)) {
            if ( transform.currentDataPoint && transform.drawArea ) {
                var coords = new OpenSeadragon.Point(event.position.x, event.position.y);
                transform.startPoint = coords;
                transform.transforming = true;
                event.preventDefaultAction = true;
                return true;
            } else {
                transform.transforming = false;
                return false;
            }
        }
    }
    
    function _onViewerDrag( event, transform ) {
        if ( transform.isTransforming() ) {
            var newPoint = new OpenSeadragon.Point(event.position.x, event.position.y);//.times(1/window.devicePixelRatio);
            var oldPoint = imageView.CoordinateConversion.convertPointFromImageToCanvas(transform.currentDataPoint.point, transform.viewer)
            var pNew = null;//rect.getTopLeft();
            if ( transform.drawArea === imageView.DataPoint.HitAreas.POINT ) {
            	pNew = newPoint;
            } else if ( transform.drawArea === imageView.DataPoint.HitAreas.LINE_X ) {
            	pNew = new OpenSeadragon.Point(oldPoint.x,newPoint.y);
            } else if ( transform.drawArea === imageView.DataPoint.HitAreas.LINE_Y ) {
            	pNew = new OpenSeadragon.Point(newPoint.x,oldPoint.y);
            } else {
            	pNew = oldPoint;
            }
            var pImage = imageView.CoordinateConversion.convertPointFromCanvasToImage(pNew, transform.viewer);
            transform.currentDataPoint.point = pImage;
            transform.viewer.forceRedraw();
            event.preventDefaultAction = true;
            return true;
        }
    }
    
    function _onViewerRelease( event, transform ) {
        if ( transform.isActive() ) {
            if ( transform.transforming ) {
                transform.finishedObservable.next(transform.currentDataPoint);
            }
            transform.transforming = false;
            event.preventDefaultAction = true;
            return true;
        }
    }
    
    function _onViewerDragEnd( event, transform ) {
        if ( transform.isTransforming() ) {
            transform.transforming = false;
            event.preventDefaultAction = true;
            return true;
        }
    }
    
    function _disableViewerEvent( event, transform ) {
        if ( transform.isTransforming() ) {
            event.preventDefaultAction = true;
            return true;
        }
    }

